// extracted by mini-css-extract-plugin
module.exports = {"accountMenu":"src-hellospa-components-global-header-account-menu__accountMenu--6pFq9"};